import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Typography } from '@mui/material';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const MAlert = ({ iconType, message, severity, variant, ...otherProps }) => {
  let errorList;

  const formatMessage = text => {
    let parsedMessage = text;
    if (text?.includes(':')) {
      [parsedMessage, errorList] = text.split(':');
      parsedMessage += ':';
      if (errorList) {
        errorList = errorList.trim().split(';');
      }
    }
    return parsedMessage;
  };

  return (
    <Alert
      icon={iconType}
      iconMapping={
        // if an icon is not provided the iconMapping will be default
        // and has to return an object of some sort or errors are thrown
        !iconType
          ? {
              error: <ErrorRoundedIcon sx={{ color: 'error.main' }} />,
              success: <CheckCircleRoundedIcon sx={{ color: 'primary.main' }} />,
            }
          : {}
      }
      severity={severity}
      variant={variant}
      {...otherProps}
    >
      <Typography color="inherit" variant="caption">
        {formatMessage(message)}
      </Typography>
      {errorList && (
        <Box display="flex" flexDirection="column" p={1.25}>
          {errorList.map(
            (error, idx) =>
              error && (
                <Typography color="inherit" key={error} variant="caption">
                  {`${idx + 1}. ${error}`}
                </Typography>
              )
          )}
        </Box>
      )}
    </Alert>
  );
};

MAlert.propTypes = {
  iconType: PropTypes.node,
  message: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  variant: PropTypes.string,
};

MAlert.defaultProps = {
  iconType: null,
  variant: 'filled',
};

export default MAlert;
